var map = {
	"./android.webp": 9,
	"./android_1.webp": 9721,
	"./beiban.webp": 4635,
	"./bg.webp": 2797,
	"./bgMs.webp": 9905,
	"./bj.webp": 7558,
	"./sudu01.webp": 5786,
	"./sudu02.webp": 7675,
	"./sudu03.webp": 296,
	"./sudu04.webp": 2209,
	"./sudu05.webp": 6886,
	"./text-no1.webp": 902,
	"./three.webp": 738,
	"./xiej.webp": 8886
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7601;